import { CommonModule } from '@angular/common';
import {
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { catchError, concatMap, debounceTime, filter, forkJoin, map, of, Subject, switchMap, tap } from 'rxjs';

import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DpTableComponent } from '../../../../common-component/dp-table/dp-table.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DpInputFieldComponent } from '../../../../common-component/dp-input-field/dp-input-field.component';
import { DpLoaderComponent } from '../../../../common-component/dp-loader/dp-loader.component';
import { LoaderComponent } from '../../../../common-component/loader/loader.component';
import { ManageUserService } from '../../../../services/raintree/Transmission/manage-user.service';
import { CommonUtilService } from '../../../../services/common-util/common-util.service';

import { ToastrService } from 'ngx-toastr';
import { ManageUserDialogComponent } from '../manage-user-dialog/manage-user-dialog.component';
import { AppConfigService } from '../../../../services/config/app-config.service';
import { DistrictListService } from '../../../../services/raintree/Transmission/district-list.service';
import { SatesListService } from '../../../../services/raintree/Transmission/sates-list.service';
import { PincodeDetailsData } from '../../../../services/raintree/interfaces/pincode';
import { PincodeDetailsService } from '../../../../services/raintree/Transmission/pincode-details.service';

@Component({
  selector: 'app-filter-dialog',
  standalone: true,
  imports: [
    MatIconModule,
    MatDividerModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    LoaderComponent,
    InfiniteScrollModule
  ],
  templateUrl: './manage-user-filter-dialog.component.html',
  styleUrl: './manage-user-filter-dialog.component.scss'
})
export class FilterDialogComponent implements OnInit {
  isMobileView: boolean = false;
  isLoading: boolean = false;
  locationAccess: any;

  states: any = [];
  stateList: any = [];
  selectedState: string = '';

  districts: { [key: string]: any[] } = {};
  myDistricts: any = '';
  districtList: { [key: string]: any[] } = {};
  selectedDistrict: string = '';

  pincode: string = '';

  levels: string[] = ["ALL LEVEL"];
  selectedLevel: string = "ALL LEVEL";
  pincodeFilterTerm = new FormControl<string>('');

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private isMobile: CommonUtilService,
    private toaster: ToastrService,
    private dialogRef: MatDialogRef<ManageUserDialogComponent>,
    private _pincodeDetails: PincodeDetailsService,
    private selectDistrictList: DistrictListService
  ) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.isMobileView = this.isMobile.isMobileDevice();

    this.stateList = this.data.stateList;
    this.districtList = this.data.districtList;

    this.states = this.data.stateList;
    this.districts = this.data.districtList;
    this.levels = this.data.levelList;

    this.selectedState = this.data.selectedState;
    this.selectedDistrict = this.data.selectedDistrict;
    this.selectedLevel = this.data.selectedLevel;

    this.isLoading = false;

    this.pincodeFilterTerm.valueChanges.pipe(
      debounceTime(600),
    ).subscribe((data: any) => {
      console.log("data:", data);
      if (data?.length == 6 || data?.length == 0) {
        this.fetchPincodeDetils(data)
      }
    })

  }

  displayDistrict(state: any) {
    if (!this.districts[state] || this.districts[state].includes('ALL')) {
      this.selectDistrictList.getDistrictList(state).pipe(
        map((response: any) => response.data.map((elm: any) => elm.district_name)),
        tap(districts => {
          this.districts[state] = districts;
        }
        )).subscribe();
    }
  }

  closeDialog() {
    this.dialogRef.close(false);
  }

  applyFilter() {
    this.dialogRef.close({
      selectedState: this.selectedState,
      selectedDistrict: this.selectedDistrict,
      selectedLevel: this.selectedLevel
    });
  }

  onStateChange() {
    // this.fetchDistricts(this.selectedState);
    if (
      this.districts[this.selectedDistrict] ||
      this.districts[this.selectedState].length == 0
    ) {
      this.districts[this.selectedDistrict] = [];
    }
    this.selectedDistrict = '';
  }
  clearStateSelection() {
    this.selectedState = '';
    this.selectedDistrict = '';
    this.pincodeFilterTerm.setValue('');
  }
  clearDistrictSelection() {
    this.pincodeFilterTerm.setValue('');
    this.selectedDistrict = '';
  }

  fetchPincodeDetils(data: string): void {
    this.isLoading = true;
    this.pincode = data;
    console.log("Pincode:", this.pincode);
    if (this.pincode == '') {
      this.states = this.stateList;
      this.districts = this.districtList;
    } else {
      console.log("Calling API");
      this._pincodeDetails.fetchPincodeDetails(data).subscribe({
        next: (response: any) => {
          let state_name_array =  Object.keys(response.data);
          let districtName = Object.keys(response.data[state_name_array[0]]);
          // if(state_name_array.length == 1){
          this.states = this.stateList.filter((item: string) => state_name_array.includes(item));
          this.districts = Object.entries(this.districtList)
            .filter(([state]) => this.states.includes(state)) // Keep only valid states
            .reduce<Record<string, string[]>>((acc, [state, districts]) => {
              const filteredDistricts = districts.filter(district => districtName.includes(district));
              if (filteredDistricts.length > 0) {
                acc[state] = filteredDistricts; // Add only if at least one district is valid
              }
              return acc;
            }, {});

          console.log(this.states);
          console.log(this.districts);
         

          if (this.states.length == 0 || !this.districts[this.states[0]] || this.districts[this.states[0]].length == 0) {
            this.states = this.stateList;
            this.districts = this.districtList;
            this.toaster.error(`Please enter Pincode within your area`);
            return;
          }

          this.selectedState = this.states.length > 0 ? this.states[0] : this.selectedState;
          this.selectedDistrict = this.districts[this.selectedState].length > 0 ? this.districts[this.selectedState][0] : this.selectedDistrict;

          console.log("States: ", this.states);
          console.log("District: ", this.districts);
        },
        error: (error) => {
          this.isLoading = false;
          this.toaster.error(error);
        },
      });
    }
    this.isLoading = false;
  }

  clearPincodeSelection() {
    this.states = this.stateList;
    this.districts = this.districtList;
    this.pincodeFilterTerm.setValue('');
  }


}
